import React from "react";
import Login from "../components/login/Login";

const LoginRoute = [{ path: "/auth", element: <Login /> }];

export default LoginRoute;
